<template>
  <v-container class="content">
    <div
      v-if="loading"
      class="loader"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
    </div>
    <div v-else>
      <v-row>
        <v-col
          cols="12"
          lg="4"
          class="pr-lg-12"
        >
          <router-link
            class="all-services"
            :to="backLink"
          >
            <v-icon
              color="peacock"
              width="15px"
            >
              mdi-arrow-left
            </v-icon>
            <span class="ml-4">{{ $t('service_details.txt.all_services') }}</span>
          </router-link>
          <v-card
            outlined
            class="mt-12 detail-card"
          >
            <ServiceDetailCard
              :service="service"
              :service-annual-price="serviceAnnualPrice"
              :service-annual-subscribable="annualSubscribable"
              :service-month-price="serviceMonthPrice"
              :service-monthly-subscribable="monthlySubscribable"
              :month="monthlyCostToSend"
              :year="yearlyCostToSend"
              :activated-vehicles-count="activatedVehiclesCount"
            />
          </v-card>
        </v-col>
        <v-col
          cols="12"
          lg="8"
        >
          <ServiceDetailList
            :service="service"
            @monthlyCost="monthlyCostReceived"
            @yearlyCost="yearlyCostReceived"
            @activatedVehiclesCount="onActivatedVehiclesCount"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import ServiceDetailCard from '@/components/ServiceDetailCard.vue'
import ServiceDetailList from '@/components/ServiceDetailList.vue'
import prismicService from '@/helpers/prismicService'
import { mapState, mapActions } from 'vuex'
import { ProductType } from '@/helpers/enums'

export default {
  name: 'ServiceManagement',

  components: {
    ServiceDetailCard,
    ServiceDetailList
  },

  data: () => ({
    service: {},
    monthlyCostToSend: 0,
    yearlyCostToSend: 0,
    serviceAnnualPrice: 0,
    annualSubscribable: false,
    serviceMonthPrice: 0,
    monthlySubscribable: false,
    loading: false,
    /** Preenchido pelo ServiceDetailList (evita 2× GET trucks/services/detail). */
    activatedVehiclesCount: null
  }),
  computed: {
    ...mapState('account', ['currency']),
    backLink() {
      return this.service.type__c == ProductType.Service
        ? {
            name: 'portal-services',
            params: { flagVehicles: false, type: ProductType.Service }
          }
        : {
            name: 'data-services',
            params: { flagVehicles: false, type: ProductType.DataService }
          }
    }
  },
  watch: {
    currency(newValue) {
      if (newValue && newValue.code) {
        this.setServicePrice(this.service, newValue)
      }
    }
  },
  async created() {
    this.loading = true
    await this.getServiceInformation()
    this.loading = false
  },
  methods: {
    ...mapActions('products', ['getServicesProducts']),
    getServiceInformation() {
      const id = this.$router.history.current.params.id
      return this.getServicesProducts().then(services => {
        this.service = services.find(service => service.id === id)
        if (this.service) {
          this.setServicePrice(this.service, this.currency)

          return prismicService.getProductCatalog().then(catalog => {
            catalog.find(catalogProduct => {
              if (catalogProduct.externalKey === this.service.sku) {
                this.service.serviceName = catalogProduct.title
                this.service.iconUrl = catalogProduct.iconActiveUrl
                this.service.description = catalogProduct.description
              }
            })
          })
        }
      })
    },
    setServicePrice(newService, newCurrency) {
      newService.productRatePlans.forEach(product => {
        product.productRatePlanCharges.forEach(bp => {
          if (bp.billingPeriod === 'Annual') {
            const annualprice = bp.pricing.find(
              pr => pr.currency === newCurrency.code
            )

            this.annualSubscribable = product.isAllowedToSubscribe__c == 'True'
            this.serviceAnnualPrice = annualprice && annualprice.price
          } else if (bp.billingPeriod === 'Month') {
            const monthPrice = bp.pricing.find(
              pr => pr.currency === newCurrency.code
            )

            this.monthlySubscribable = product.isAllowedToSubscribe__c == 'True'
            this.serviceMonthPrice = monthPrice && monthPrice.price
          }
        })
      })
    },

    monthlyCostReceived(monthlyCost) {
      this.monthlyCostToSend = monthlyCost
    },
    yearlyCostReceived(yearlyCost) {
      this.yearlyCostToSend = yearlyCost
    },
    onActivatedVehiclesCount(count) {
      this.activatedVehiclesCount = count
    }
  }
}
</script>

<style lang="scss">
.content {
  margin-bottom: 260px;

  @media screen and (min-width: 600px) {
    margin-bottom: 200px;
  }
  @media screen and (min-width: 960px) {
    margin-bottom: 140px;
  }
  .loader {
    text-align: center;
    padding-top: 48px;
  }
  .all-services {
    font-size: 0.875rem;
    font-weight: bold;
    color: var(--v-mid-base);
    text-transform: uppercase;
    text-decoration: none;
  }
  .detail-card {
    border-radius: 8px !important;
  }
}
</style>